import React, { useState } from "react";
import api from "../../../utils/api";
import CustomeSignInPopup from "./CustomeSignInPopup";
import { toast } from "react-toastify";
import { showCustomAlert } from "./Toast";
import Cookies from 'js-cookie'
import Swal from "sweetalert2";
const OtpPopup = () => {
   const [popupType, setPopupType] = useState(null);
  const [isOpen, setIsOpen] = useState(true); // Modal visibility
  const [otp, setOtp] = useState(new Array(6).fill("")); // Array for OTP inputs
  const [loading, setLoading] = useState(false); // Loading state for API call
  const [resending, setResending] = useState(false); // Loading state for resend OTP

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleChange = (element, index) => {
    const value = element.value;

    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && element.nextSibling) {
        // Move focus to the next input if a digit is entered
        element.nextSibling.focus();
      }
    }
  };

  const handleKeyDown = (event, index) => {
    const currentOtp = [...otp];

    if (event.key === "Backspace") {
      if (currentOtp[index] === "" && event.target.previousSibling) {
        // Focus on the previous field without removing its value
        event.target.previousSibling.focus();
      } else if (currentOtp[index] !== "") {
        // Remove current field's value
        currentOtp[index] = "";
        setOtp(currentOtp);
      }
    }
  };

  const handleSubmit = async () => {
    // Get email from localStorage
    const email = localStorage.getItem("email");
    if (!email) {
      toast.error("Email not found in localStorage");
      return;
    }
  
    // Check if OTP is 6 digits long
    if (otp.join("").length !== 6) {
      showCustomAlert({
        title: 'Failed',
        html: '<p style="color: #555;">Please enter a valid 6-digit OTP</p>',
        icon: 'error',
        confirmButtonText: 'Continue',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
      return;
    }
  
    // Prepare payload with email and OTP
    const payload = {
      email,
      otp: parseInt(otp.join(""), 10), // Convert OTP array to integer
    };
    console.log("🚀 ~ handleSubmit ~ payload:", payload);
  
    setLoading(true);
  
    try {
      // Send the OTP verification request
      const response = await api.post("/auth/verify-account", payload);
      console.log("🚀 ~ handleSubmit ~ response:", response);
  
      // Get the reward status from cookies
      const gethere = Cookies.get('reward');
  
      if (response.status === 200) {
        if (gethere) {
          // Show reward popup if `gethere` is true
          Swal.fire({
            title: 'Congratulations!',
            html: '<p style="color: #555;">your account is created successfully!</p>',
            icon: 'success',
            showConfirmButton: false,
            confirmButtonColor: '#af313d',
            background: '#ffffff',
          });
        } else {
          // Show normal OTP verification success popup
          Swal.fire({
            title: 'OTP Verified',
            html: '<p style="color: #555;">OTP verified successfully</p>',
            icon: 'success',
            confirmButtonText: 'Continue',
            confirmButtonColor: '#af313d',
            background: '#ffffff',
          });
        }
        
        setPopupType('login');
        handleClose(); 
      } else {
        showCustomAlert({
          title: 'OTP Not Verified',
          html: '<p style="color: #555;">Failed to verify</p>',
          icon: 'error',
          confirmButtonText: 'Continue',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
        });
      }
    } catch (error) {
      toast.error("An error occurred while verifying the OTP");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  

  const handleResendOtp = async () => {
    const email = "bsf2100874@ue.edu.pk"; // Fetch email from localStorage
    // localStorage.getItem("email")
    if (!email) {
      toast.error("Email not found in localStorage");
      return;
    }

    const payload = { email };

    setResending(true);

    try {
      const response = await fetch(
        "https://cashback-479780104538.europe-west2.run.app/api/auth/regenerate-otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log("🚀 ~ handleResendOtp ~ data:", data)

      if (response.ok) {
        toast.success("OTP has been resent successfully", {
          style: {
            backgroundColor: "white", // Background color
            color: "#AD343E", // Text color
          },
          icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
        });
      } else {
        toast.error(data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error("An error occurred while resending the OTP");
      console.error(error);
    } finally {
      setResending(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
            <h2 className="text-xl font-bold text-center mb-4">Verify Your Account</h2>
            <p className="text-gray-600 text-center mb-6">
              Enter the 6-digit OTP sent to your phone number/email.
            </p>
            <div className="flex justify-center gap-2 mb-6">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-12 h-12 text-center border border-gray-300 rounded focus:ring-2 focus:ring-[#af313d] focus:outline-none text-lg"
                />
              ))}
            </div>
            <button
              onClick={handleSubmit}
              className="w-full bg-[#af313d] text-white py-2 rounded hover:bg-[#af313d] disabled:bg-gray-400"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
            <p className="text-center text-sm text-gray-500 mt-4">
              Didn’t receive the OTP?{" "}
              <button
                onClick={handleResendOtp}
                className="text-[#af313d] hover:underline disabled:text-gray-400"
                disabled={resending}
              >
                {resending ? "Resending..." : "Resend OTP"}
              </button>
            </p>
          </div>
        </div>
      )}
       {popupType === "login" && (
        <CustomeSignInPopup closePopup={() => setPopupType(null)} />
      )}
    </>
  );
};

export default OtpPopup;
